export default __webpack_public_path__ + "static/media/escudo_ranking3.8065c708.png";